<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{ headingText }}</h4>

  <mat-accordion>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title> Ricerca </mat-panel-title>
        <mat-panel-description>
          Ricerca Avanzata Incarichi
        </mat-panel-description>
      </mat-expansion-panel-header>
      <search-incarichi [(search)]="search"></search-incarichi>
    </mat-expansion-panel>
  </mat-accordion>

  <div *ngIf="!loading; else loader">
    <resourceful-index
      #index
      [search]="search"
      [modelService]="incaricoService"
      [deleteFunction]="deleteFunction"
      [columnDefinitions]="columnDefinitions"
      [editFunction]="editFunction"
      [selectionMode]="selectionMode"
      (selectedModel)="closeDialogWithSelectedModel($event)"
      [relations]="relations"
    >
    </resourceful-index>

    <mat-divider></mat-divider>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi un Incarico<mat-icon>add</mat-icon>
    </button>
  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
